import { Link } from "react-router-dom";

const footerLinks = [
  { to: "/om-oss", label: "Om" },
  { to: "/kontakt", label: "Kontakt" },
  // { to: "/villkor", label: "Villkor" },
  // { to: "/integritet", label: "Integritet" },
] as const;

/**
 * Minimal footer for landing / editorial pages.
 */
const LandingMinimalFooter = () => (
  <footer className="mt-16 sm:mt-20 border-t border-border/15">
    <div className="container py-8 pb-10 flex flex-col items-center gap-4">
      <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
        {footerLinks.map(({ to, label }) => (
          <Link
            key={to}
            to={to}
            className="text-xs text-muted-foreground/60 hover:text-muted-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-sm"
          >
            {label}
          </Link>
        ))}
      </nav>
      <p className="text-xs text-muted-foreground/40 select-none">
        © Farmly
      </p>
    </div>
  </footer>
);

export default LandingMinimalFooter;
